
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { PasswordEmailModel } from '../../models/EmailPasswordChangeModel';

import { UserResetmail, UserResetPasswordResponse, UserValidationChild, XdecryptRequest } from '../../models/UserModel';

import { LoginService } from '../../services/login.service';
 

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']

})

export class ResetpasswordComponent  {

    fieldTextType: boolean;
    confirmTieldTextType:boolean;
    resetPasswordForm: FormGroup;

    private userResetPasswordResponse : UserResetPasswordResponse;
    displayReset: boolean = false;
    displayInvalid : boolean = false;
    displayClient : boolean;
    defaultLanguage :string;
    pwdMustMatch : boolean;
    updatedPassword : string;
    IsPwdLenghtNotCorrect : boolean = false;
    IsPwdRerquired :boolean =false;
    generatedPassword : string ;
    userName :string;
    passwordResetModel : PasswordEmailModel;
    displayInvalidScreen : boolean;
    xecryptRequest : XdecryptRequest;
    myDate : string;
    displayClientSelection : boolean;
    clients : object;
    resetPasswordButton : boolean = true;
    userDetails : UserValidationChild;    
    constructor(private route: ActivatedRoute,
      private formBuilder: FormBuilder,
      private loginService: LoginService,
      private  translate: TranslateService,
      private _router: Router,
      private pipe: DatePipe){
        this.userResetPasswordResponse = new UserResetPasswordResponse(),
        this.passwordResetModel = new PasswordEmailModel();
        this.xecryptRequest = new XdecryptRequest();
        this.userDetails = new UserValidationChild();
    }
     
    ngOnInit() {

       

      this.resetPasswordForm = this.formBuilder.group({
        userPassword: ['', [Validators.minLength(8)]],
        confirmUserPassword: ['', [Validators.minLength(8)]]
      });

        const userName = this.route.snapshot.queryParams['userName'];
        const password = this.route.snapshot.queryParams['password'];
        const timestamp =this.route.snapshot.queryParams['Timestamp'];
        const languagecode =this.route.snapshot.queryParams['Languagecode'];
  this.userResetPasswordResponse.Username = userName;
  this.userResetPasswordResponse.TlPsw = password;
  this.userResetPasswordResponse.TimeStamp = timestamp;
  this.userResetPasswordResponse.Languagecode = languagecode;

 
        if (userName !== (null || "") && password !== (null || "") && timestamp !=(null||"")) {
          this.loginService.IsValidEmail(this.userResetPasswordResponse).subscribe(
             
              
             (data) => {
                //inorder to avoid escape sequence security issue 
               
               if(data.TlPsw!=(null|| ""))
               {  
              while (data.TlPsw.indexOf('+') !== -1)
              {
                data.TlPsw  = data.TlPsw .replace('+', ' ');
              }
            }
            
            
            this.translate.currentLang = data.Languagecode; 
                           if(this.translate.currentLang=="FR")
                           {
                            this.translate.currentLang ="NL"
                           }
                           else{
                            this.translate.currentLang ="FR"
                           }
                           this.changeLanguage();

                           this.generatedPassword =  data.TlPsw  ; 
                           this.userName = data.Username;
                          let mailSentDate = moment(data.TimeStamp, 'DD-MM-YYYY hh:mm:ss').toDate();  

 this.loginService.GetUser(data.Username).subscribe(
    (data) => {
      if (data == 'Failed') {
        this.displayReset = false;
        this.displayInvalid = true;
      }
      else {
        if(data.FlChgPsw == true)
      {
               let resetdate= new Date();
               if (resetdate <mailSentDate ) {
                this.xecryptRequest.str= this.generatedPassword;
                this.loginService.Xdecrypt(this.xecryptRequest).subscribe(
                  (data)=>{
                    if(data.XDecryptResult != (null||''))
                    {
                      this.userDetails.UserName = this.userName;
                      this.userDetails.Password= data.XDecryptResult;
                      this.loginService.IsValidateUser(this.userDetails).subscribe(
                        (data)=>
                        {
                          if(data.Status=="Valid")
                          {
                            this.displayReset = true;
                          }
                          else {   
                
                          this.displayReset = false;
                          this.displayInvalid = true;
            
                           }
                        }
                      );
                    }
                    else {   
                
                      this.displayReset = false;
                      this.displayInvalid = true;
        
                       }
                  });
                
               }

               else {   
                
                this.displayReset = false;
              this.displayInvalid = true;

               }
      }
               else {   
                this.displayReset = false;
              this.displayInvalid = true;

               }
              }
            });
             },
             (err) => {
              this.displayReset = false;
              this.displayInvalid = true;
             }
           );
         } else {
          this.displayReset = false;
          this.displayInvalid = true;
         }
      
    }

    toggleFieldTextType() {
        this.fieldTextType = !this.fieldTextType;
        
      }

      toggleConfirmFieldTextType() {
        
        this.confirmTieldTextType = !this.confirmTieldTextType;
      }
      ResetPassword()
      {
        if (this.resetPasswordForm.get('userPassword').value == (null || undefined || '') || this.resetPasswordForm.get('confirmUserPassword').value == (null || undefined || '')) {
          this.IsPwdRerquired = true;
          return false;
        }
        else
        {
          this.IsPwdRerquired = false;
        }

        if (this.resetPasswordForm.get('userPassword').status == 'INVALID' || this.resetPasswordForm.get('confirmUserPassword').status == 'INVALID') {
          this.IsPwdLenghtNotCorrect = true;
          return false;
        }

        else{
          this.IsPwdLenghtNotCorrect =false;
        }
     
          if(this.passwordMatchValidation())
          {
            this.resetPasswordButton = false;
            this.loginService.GetUser(this.userName).subscribe(
              (data) => {
                if (data == 'Failed') {
                  this.displayReset = false;
                  this.displayInvalid = true;
                }
                else {
                  if(data.IdUsr != this.userName && data.LbSta =="FINAL" && data.FlChgPsw == true)
                  { 
                    //decrypt thr generated password
                    this.xecryptRequest.str= this.generatedPassword;
                    this.loginService.Xdecrypt(this.xecryptRequest).subscribe(
                      (data)=>{
                        if(data.XDecryptResult != (null||''))
                        {
                          //Reset the password 
                          this.passwordResetModel.UserName = this.userName;
                          this.passwordResetModel.Password = data.XDecryptResult;
                          this.passwordResetModel.NewPassword = this.resetPasswordForm.get('userPassword').value;
                          this.loginService.ChangePassword(this.passwordResetModel).subscribe(
                            (data)=>
                            {
                              if(data== true)
                              {
                                this.userDetails.UserName = this.userName;
                                this.userDetails.Password= this.passwordResetModel.NewPassword;
                                this.loginService.IsValidateUser(this.userDetails).subscribe(
                                  (data)=>
                                  {
                                       if(data.Status=="Valid")
                                       {
                                         
                                        this.displayClientSelection = false;
                                        this.displayClient = true;
                                         this.displayReset = false;
                                          this.displayInvalid = false;
                                          this.clients=  data.ClientsData;
                                          sessionStorage.setItem('Email', data.Email);
                                          sessionStorage.setItem("NoIntervenant", (data.UserName).substring(3,data.UserName.length));
                                          sessionStorage.setItem("token", data.Token);
                                       }
                                  },
                                  (err)=>
                                  {
                                    this.displayReset = false;
                                    this.displayInvalid = true;
                                  }
                                )
                                
                                // this._router.navigateByUrl('login/app-authentication');
                              }
                              else{
                                this.displayReset = false;
                                this.displayInvalid = true;
                              }
                            },
                            (err)=>
                            {
                              this.displayReset = false;
                              this.displayInvalid = true;
                              
                            });
    
                        }
    
                      },
                      (err)=>{
                        this.displayInvalid = true;
                        this.displayReset = false;
                      });
                  }
                  else{
                    this.displayReset = false;
                    this.displayInvalid = true;
                  }
                }
              },
              (err) => {
                this.displayReset = false;
                this.displayInvalid = true;
              });
          }
          else{
            return false;
          }
      
        //call getuser to check flag and status
       


       
      }
      changeLanguage() {

        if (this.translate.currentLang == 'FR') {
          this.defaultLanguage = "NL";
          
          sessionStorage.setItem("currentlang", "NL")
          sessionStorage.setItem("presentLang", "Even geduld, we zijn uw gegevens aan het laden");
          document.getElementById('languageDropdown').innerHTML = 'FR';
          (<HTMLImageElement>document.getElementById("langlogo")).src = 'assets/Logos/logo-NL.svg';
        } else {
          this.defaultLanguage = "FR";
           
          sessionStorage.setItem("currentlang", "FR")
          sessionStorage.setItem("presentLang", "Veuillez patienter  svp, nous chargeons vos données");
          document.getElementById('languageDropdown').innerHTML = 'NL';
          (<HTMLImageElement>document.getElementById("langlogo")).src = 'assets/Logos/logo-FR.svg';
        }
        this.switchLang(this.defaultLanguage);
      }
      switchLang(lang: string) {
        this.defaultLanguage = lang;
        this.translate.use(lang);
      }
      passwordMatchValidation() {
        if (this.resetPasswordForm.get('userPassword').value !== this.resetPasswordForm.get('confirmUserPassword').value) {
          this.pwdMustMatch = true;
          return false;
        }
        else {
          this.pwdMustMatch = false;
          return true;
        }
      }
      
}